import { sortBy } from '@st/utils'

export const useLockEventsStore = defineStore('lockEvents', () => {
  const MS = useMarketsStore()

  const lockedEventsIds = ref<number[]>([])
  const lockedEventsIdsSet = computed(() => new Set(lockedEventsIds.value))

  function addLockedEvent(eventId: number) {
    lockedEventsIds.value.push(eventId)
  }

  function removeLockedEvent(eventId: number) {
    lockedEventsIds.value = lockedEventsIds.value.filter((id) => id !== eventId)
  }

  function isLocked(eventId: number) {
    return lockedEventsIdsSet.value.has(eventId)
  }

  const lockedEvents = computed(() => {
    const events = MS.sportEvents.filter(({ id }) =>
      lockedEventsIds.value.includes(id),
    )
    return sortBy(events, (event) => [lockedEventsIds.value.indexOf(event.id)])
  })

  return {
    lockedEvents,
    addLockedEvent,
    removeLockedEvent,
    isLocked,
  }
})
